import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from "gatsby";
import { map } from 'lodash/fp'
import locales from '../../i18n/config';

// contexts
import LocaleContext from '../../LocaleContext';

// helpers
import { delocalizePath, localizePath } from '../../helpers/localeHelpers';


// styles
import './language-selector.scss';

const LanguageSelector = ({path, inverted, halfPage, languageSelectorInformation}) => {
    const { locale } = useContext(LocaleContext);
    const delocalizedPath = delocalizePath(path, locale);

    const onClickHandler = () => {
        if (typeof window !== 'undefined' && window.Cookiebot && !window.Cookiebot.consented) {
            setTimeout(() => {
                window.Cookiebot.init()
            }, 500)
        }
    }

    return (
        <div className={`language-selector ${inverted ? 'inverted' : ''} ${halfPage ? 'half-page' : ''}`}>
            <ul className={`language-selector__list ${inverted ? 'inverted' : ''} ${halfPage ? 'half-page' : ''}`}>
                {
                    map(localeItem => {
                        const localePath = !languageSelectorInformation || languageSelectorInformation.localesList.includes(localeItem.name) ? delocalizedPath : languageSelectorInformation.fallback;

                        if(localeItem.name === locale) {
                            return <li key={localeItem.name}><span>{localeItem.displayName}</span></li>
                        }
                        return <li key={localeItem.name}><Link to={localizePath(localePath, localeItem.name) || '/'} onClick={() => onClickHandler()} >{localeItem.displayName}</Link></li>

                    }, locales)
                }
            </ul>
        </div>
)};

LanguageSelector.propTypes = {
  path: PropTypes.string.isRequired,
    inverted: PropTypes.bool.isRequired,
    halfPage: PropTypes.bool.isRequired
};

export default LanguageSelector;
